import { Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import { CancelIcon, CheckMarkIcon, SaveIcon } from "../../../common/icons";
import { useApolloClient, useMutation } from "@apollo/client";
import { ORG_VALUE_LISTS } from "../../../../graphql/valuelist-gql";
import { IValueListLight } from "../../../../types/valuelist";
import {  useEffect, useState } from "react";
import {  GET_ORG_ROLES, GET_ROLE_DETAIL, UPDATE_ROLE } from "../../../../graphql/position-gql";
import { notifySuccess } from "../../../../services/notification";
import { messages } from "../../../../i18n/message";
import { LOCALES } from "../../../../i18n/locales";
import { IPosition, IPositionInput, IPositionTitle } from "../../../../types/position";
import PositionTypeahead from "../../../common/typeahead/position-typeahead";
import Select from "../../../common/select/select";
import { formatExcludeComma } from "../../../../types/constants";
import { deepEqual } from "../../../../utils/commons";
import Info from "../../../common/info";
import useAuth from "../../../../hook/useAuth";
import { useFrench } from "../../../french/french-context";
import Button from "../../../common/button";
import SpinnerOverlay from "../../../common/spinner/spinner";

type RoleInformationProp = {
    role:IPosition
    updateSelectedRole?:(updatedRole:IPosition)=>void
    //onUpdatePositionName:(name:string)=>void
}

const RoleInformationGrp =(prop:RoleInformationProp)=>{
    const {role,updateSelectedRole} = prop;
    const [suffixLengthError,setSuffixLengthError] = useState<string>('');
    const [suffixCharError,setSuffixCharError] = useState<string>('');
    const [titleError,setTitleError] = useState<string>('');
    const [selectedPositionTitle,setSelectedPositionTitle] = useState<IPositionTitle>({positionTitleId:role.positionTitle.positionTitleId,positionName:role.positionTitle.positionName});
    const [anyChange,setAnychange] = useState<boolean>(false);
    const [valid,setValid] = useState<boolean>(true);
    const [ updateRole, {loading} ] = useMutation(UPDATE_ROLE);
    const [defaultSeparatorId,setDefaultSeparatorId] =useState<number>(0);
    const [positionFullTitle,setPositionFullTitle] =  useState<string>('');
    const client = useApolloClient()
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
    const { isFrenchTranslator } = useAuth()
    const [frenchState] = useFrench();
    const getDefaultSeparator = () =>{
        const obj = orgValueLists.posSeparators.filter(((item: any) =>
         {
              return item.label == 'Blank' || item.code == 'BLANK'
         } ))
        setDefaultSeparatorId(obj[0].id);
        return obj[0].id;
     }
     const [editedRole, setEditedRole] = useState<Partial<IPositionInput>>(
         {positionTitleId:0, positionHonorificId:0, positionSeparator:"",positionSeparatorId: 0,positionPortfolio:'', positionName:'',
          bilingualIndicator:false
         }
    )
    const initRoleInput = () => {
        let separatorId = 0;
        let separatorStr = "";
        if(role.positionSeparator == null){
           separatorId = getDefaultSeparator();
           separatorStr = "";
        }else{
            separatorId = role.positionSeparator?.id;
            separatorStr = role.positionSeparator.label;

        }
        const init : IPositionInput = {
            positionTitleId: role.positionTitle.positionTitleId,
            positionName: role?.positionName,
            positionHonorificId:role.positionHonorificId,
            positionPrefix:role.positionPrefix?role.positionPrefix:'',
            positionPortfolio:role.positionPortfolio?role.positionPortfolio:'',
            bilingualIndicator:role.bilingualIndicator,
            managementIndicator:false,
            positionSeparatorId: separatorId,
            positionSeparator:separatorStr,
            positionNameFMSync: role.positionNameFMSync,
            positionNameFFSync:role.positionNameFFSync,
            positionNameFM: role.positionNameFM,
            positionNameFF: role.positionNameFF
        }
        return init;
    }

    useEffect(() => {
        getDefaultSeparator();
        console.log("role changed position name 00: " + role.positionName)
        if (role) {
            setEditedRole(initRoleInput())
            setPositionFullTitle(role.positionName)
            setSelectedPositionTitle({positionTitleId:role.positionTitle.positionTitleId,positionName:role.positionTitle.positionName})
        }
    }, [role])

    useEffect(() => {
        if(defaultSeparatorId == 0){
            getDefaultSeparator();
        }
        if(editedRole?.positionPortfolio && editedRole?.positionPortfolio?.length>100)
            setSuffixLengthError(messages[LOCALES.ENGLISH].ERROR['5612'])
        else
            setSuffixLengthError('')

        if(editedRole?.positionPortfolio && formatExcludeComma.test(editedRole?.positionPortfolio))
            setSuffixCharError(messages[LOCALES.ENGLISH].ERROR['5613'])
        else
            setSuffixCharError('')

        setAnychange(!deepEqual(initRoleInput(),editedRole));

    }, [editedRole])

    useEffect(() => {
        setValid(editedRole?.positionTitleId!==0
            && !titleError

            && !suffixCharError && !suffixLengthError)
    },[titleError,suffixCharError,suffixLengthError,editedRole]);

    const fullTitle = (positionName:string|undefined,separator:string|undefined,suffix:string|undefined) =>{
        if(separator){
            if(separator == 'Blank' || separator == 'BLANK'){
                separator = ' ' ; 
            }
        }else{
            separator = '' ; 
        }
        let fullName = '';
        if(positionName){
            if(separator && separator.trim() == ','){
                fullName = positionName + separator + (suffix?' '+suffix:'')
            }else{
                fullName = positionName +' ' + separator + (suffix?' '+suffix:'')
            }
        }else{
            fullName = separator + (suffix?' '+suffix:'')
        }
        return fullName
    }

    useEffect(()=>{
        const title = fullTitle(selectedPositionTitle.positionName,editedRole.positionSeparator,editedRole.positionPortfolio)
        setPositionFullTitle(title)
        //onUpdatePositionName(title);
    },[editedRole.positionHonorificId,editedRole.positionPrefix,selectedPositionTitle,orgValueLists.posHonorifics,editedRole.positionPortfolio,editedRole.positionName,editedRole.positionSeparatorId])

    const titleSelected = (positionTitle: IPositionTitle | null) => {
        setSelectedPositionTitle(positionTitle||{positionTitleId:0,positionName:''})
        setEditedRole({ ...editedRole, positionTitleId: positionTitle?.positionTitleId || 0, positionNameFMSync: false, positionNameFFSync: false})
    }
    const onRoleSeparatorChange = (event: any) => {
        const obj = orgValueLists.posSeparators.filter(((item: any) =>
            {
                 return item.id == event.target.value;
            } ))
            if(obj)
          //  setSelectedSeparatorLabel(obj[0].label)
        setEditedRole({ ...editedRole, positionSeparatorId: event.target.value,positionSeparator: obj[0].label, positionNameFMSync: false, positionNameFFSync: false })
    }
    const onRoleSuffixChange = (event: any) => {
        setEditedRole({ ...editedRole, positionPortfolio: event.target.value, positionNameFMSync: false, positionNameFFSync: false })
    }
    const onHonorificChange = (event: any) => {setEditedRole({ ...editedRole, positionHonorificId: event.target.value })}
    const onbilingualIndicatorChange = (event: any) => {setEditedRole({ ...editedRole, bilingualIndicator: !editedRole.bilingualIndicator })}
    const onRoleNameFMSyncChange = (event: any)=>{setEditedRole({ ...editedRole, positionNameFMSync: event.target.checked })}
    const onRoleNameFFSyncChange = (event: any)=>{setEditedRole({ ...editedRole, positionNameFFSync: event.target.checked })}
    const getRefetchQuery = () => {return [{query: GET_ROLE_DETAIL, variables: { roleId: role.positionId}}]}
    const onSaveHandle = () => {
        const inputRole = {...editedRole}
        delete inputRole.positionName;
        delete inputRole.positionSeparator
        updateRole({
            variables: {
                roleId: role?.positionId,
                input: {
                    ...inputRole
                }
            },
            update(cache,{data:{updateRole}}){
                //update for position list
                const cachedOrg = cache.readQuery<{
                    org:{
                        roles:Array<IPosition>
                    }
                }>({
                    query: GET_ORG_ROLES,
                    variables: { orgId: role?.orgId||undefined},
                  });

                if(cachedOrg){

                    const updatedRoles = [...cachedOrg.org.roles];
                    const updatedRoleIndex = updatedRoles.findIndex(
                        (role: IPosition) => role.positionId === updateRole.positionId
                      );
                    // Modify the cache data to reflect the mutation result
                    if (updatedRoleIndex !== -1) {
                        updatedRoles[updatedRoleIndex] = updateRole;
                    }
                    // Update the cached data with the modified positions array
                    cache.writeQuery({
                        query: GET_ORG_ROLES,
                        variables: { orgId: role?.orgId||undefined},
                        data: {
                            org: {
                                ...cachedOrg.org,
                                roles: updatedRoles,
                            },
                        },
                    });
                    updateSelectedRole&&updateSelectedRole({...role,...updateRole});
                }
            },
            refetchQueries: getRefetchQuery(),
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                data && notifySuccess()
            }
        })
    }

    const honorific = () =>{
        if(editedRole.positionHonorificId && orgValueLists?.posHonorifics){
            const orgValueList = orgValueLists.posHonorifics.find((item:IValueListLight)=>item.id===editedRole.positionHonorificId)
            return orgValueList?orgValueList.label:'';
        }
    }

    return (
        <>{loading && <SpinnerOverlay></SpinnerOverlay>}
        <div className="roleDetail">
                <Info ><b>Full Title Preview:</b>&nbsp;{positionFullTitle} </Info>
                {
                        frenchState.isFrenchChecked && <>
                            <Info><b>Full Title Preview (French - Masculine):</b>&nbsp;<span lang="fr">{editedRole.positionNameFM}</span></Info>
                            <FormGroup row>
                                <div className='col-md-3'>
                                    <Input id="nameTranslated" type="checkbox" checked={editedRole?.positionNameFMSync || false} onChange={onRoleNameFMSyncChange} disabled={!editedRole.positionNameFM}/> {' '}
                                    <Label for="nameTranslated" role="region" aria-label='Translated Full Title Masculine'>Translated Full Title Masculine</Label>
                                </div>
                            </FormGroup>
                            <Info><b>Full Title Preview (French - Feminine):</b>&nbsp;<span lang="fr">{editedRole.positionNameFF}</span></Info>
                            <FormGroup row>
                                <div className='col-md-3'>
                                    <Input id="nameTranslated1" type="checkbox" checked={editedRole?.positionNameFFSync || false} onChange={onRoleNameFFSyncChange} disabled={!editedRole.positionNameFF} /> {' '}
                                    <Label for="nameTranslated1" role="region" aria-label='Translated Full Title Feminine'>Translated Full Title Feminine</Label>
                                </div>
                            </FormGroup>
                        </>
                    }
                <br/>
                { isFrenchTranslator && 
                    <>
                        <div className="row mb-3">
                            <div className="col-md-2">Title:</div>
                            <div className="col-md-4">{selectedPositionTitle.positionName}</div>
                            <div className="col-md-2">Separator:</div>
                            <div className="col-md-4">{editedRole.positionSeparator}</div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-2">Suffix:</div>
                            <div className="col-md-4">{editedRole.positionPortfolio}</div>
                            <div className="col-md-2">Honorific:</div>
                            <div className="col-md-4">{honorific()}</div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-md-12">
                                { editedRole?.bilingualIndicator ? <CheckMarkIcon /> : <CancelIcon /> }
                                &nbsp;Role is Bilingual
                            </div>
                        </div>
                    </>
                }
                { !isFrenchTranslator && 
                    <Form>
                        <FormGroup>
                            <div className="row mb-3">
                                <div className="col-md-2"><Label for="role-info-title">Title(required):</Label></div>
                                <div className="col-md-4">
                                    <PositionTypeahead 
                                        elementId="role-info-title" 
                                        positionTitleSelected={titleSelected} 
                                        init={role.positionTitle} 
                                        validate={setTitleError} 
                                        isRole={role.isRole}/>
                                </div>
                                <div className="col-md-2"><Label for="role-info-separator">Separator:</Label></div>
                                <div className="col-md-4">
                                    <Select 
                                        id="role-info-separator"
                                        value={editedRole?.positionSeparatorId || defaultSeparatorId } 
                                        onChange={onRoleSeparatorChange}>
                                        { orgValueLists.posSeparators.map((item: IValueListLight) => 
                                            <option key={item.id} value={item.id}>{item.label}</option>)
                                        }
                                    </Select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-2"><Label for="role-info-suffix">Suffix:</Label></div>
                                <div className="col-md-4">
                                    <Input 
                                        id="role-info-suffix"
                                        value={editedRole?.positionPortfolio||'' }
                                        onChange={onRoleSuffixChange}
                                        invalid={!!suffixLengthError || !! suffixCharError} maxLength={100} />
                                    <FormFeedback>{suffixLengthError}</FormFeedback>
                                    <FormFeedback>{suffixCharError}</FormFeedback>
                                </div>
                                <div className="col-md-2"><Label for="role-info-honorific">Honorific:</Label></div>
                                <div className="col-md-4">
                                    <Select
                                        id="role-info-honorific"
                                        value={editedRole?.positionHonorificId || 0 } 
                                        onChange={onHonorificChange}>
                                        <option value=''></option>
                                        { orgValueLists.posHonorifics.map((item: IValueListLight) => 
                                            <option key={item.id} value={item.id}>{item.label}</option>)
                                        }
                                    </Select>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-md-12">
                                    <Button color="primary" style={{marginRight:'20px'}} onClick={onSaveHandle} disabled={!valid || !anyChange}><SaveIcon /> Save Changes</Button>
                                    <Input id="role-info-bilingualIndicator" type="checkbox" style={{verticalAlign:'middle'}} checked={editedRole?.bilingualIndicator||false} onChange={onbilingualIndicatorChange}/>
                                    <Label for="role-info-bilingualIndicator" check style={{verticalAlign:'middle',marginRight:'20px'}}>&nbsp;Role is Bilingual</Label>
                                </div>
                            </div>
                        </FormGroup>
                    </Form>
                }                
            </div></>)
}

export default RoleInformationGrp;
